import React from "react";
import Export from "./Export";
import { exportToExcel } from "../hooks/exportToExcel";
import printChart from "../../../../../PrintChart";
import PageHeader from "../../../../../components/PageHeader";

const Header = ({ filteredData, storess, chartContainerId }) => (
  <div className="d-flex justify-content-between align-items-center">
    <PageHeader
      title="Share of Sales Contribution"
      subtitle="Analyze revenue distribution across stores and transaction types"
      icon="bi bi-pie-chart"
    />

    <Export
      exportCsv={() => exportToExcel(filteredData, storess)}
      exportPdf={() => printChart(chartContainerId)}
    />
  </div>
);

export default Header;
